import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

export const LecturerStatistics = createAsyncThunk(
  'lecturer-statistics',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/lecturer/statistics', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Lecturer
export const ListLecturer = createAsyncThunk('lecturer-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/lecturer/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Lecturer
export const createLecturer = createAsyncThunk('lecturer-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/lecturer/store', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Lecturer id
export const editLecturer = createAsyncThunk('lecturer-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lecturer/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Email Lecturer
export const emailLecturer = createAsyncThunk('lecturer-email', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/lecturer/email', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Lecturer
export const deleteLecturer = createAsyncThunk('lecturer-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/lecturer/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Toggle Archive Lecturer
export const toggleArchiveLecturer = createAsyncThunk(
  'lecturer-toggle',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/lecturer/toggle-archive/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Archived Lecturer
export const ListArchivedLecturer = createAsyncThunk(
  'archived-lecturer-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/lecturer/archived-list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// view Lecturer
export const viewLecturer = createAsyncThunk('lecturer-view', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lecturer/view/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Lecturer Document
export const ListLecturerDocument = createAsyncThunk(
  'lecturer-document-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/lecturer-document/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create Lecturer Document
export const createLecturerDocument = createAsyncThunk(
  'lecturer-document-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/lecturer-document/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Lecturer Document id
export const editLecturerDocument = createAsyncThunk(
  'lecturer-document-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lecturer-document/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete Lecturer Document
export const deleteLecturerDocument = createAsyncThunk(
  'lecturer-document-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/lecturer-document/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get publications
export const ListPublication = createAsyncThunk(
  'lec-publication-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/lec-portal/publication-list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const LecturerRegulations = createAsyncThunk('lec-regulations', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/lec-portal/regulations')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MyVideos = createAsyncThunk('lec-my-videos', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/lec-portal/video-library')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SearchVideo = createAsyncThunk(
  'video-search',
  async ({type, program, section}: {type: string; program: string; section: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lec-portal/video-search/${type}/${program}/${section}`)
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const LecturerProfile = createAsyncThunk('lec-profile', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/lec-portal/my-profile')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListMyDocument = createAsyncThunk('my-document-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/lec-portal/my-docs')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Lecturer Document
export const createMyDocument = createAsyncThunk(
  'my-document-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/lec-portal/doc-store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get publications
export const ListMyPublication = createAsyncThunk('my-publication-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/lec-portal/pub-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create publication
export const createMyPublication = createAsyncThunk(
  'my-publication-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/lec-portal/pub-store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const MyCourses = createAsyncThunk('lecture-courses', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/lec-portal/my-courses')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const courseDates = createAsyncThunk('course-date', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lec-portal/course-dates/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const courseStudents = createAsyncThunk('course-stds', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lec-portal/course-students/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentAttendance = createAsyncThunk(
  'student-attendance',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lec-portal/student-attendance/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetAttendance = createAsyncThunk('get-attendance', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`/api/lec-portal/get-attendance`, data)
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrintStudentAttendance = createAsyncThunk(
  'print-student-attendance',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lec-portal/print-attendance/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentScores = createAsyncThunk('student-score', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lec-portal/student-scores/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StoreScore = createAsyncThunk('store-score', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`/api/lec-portal/store-scores`, data)
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrintStudentScore = createAsyncThunk(
  'print-student-score',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lec-portal/print-score/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StoreRedoRetake = createAsyncThunk('store-redo-retake', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`/api/lec-portal/store-redo-retake`, data)
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentAssignments = createAsyncThunk(
  'student-assignments',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lec-portal/student-assignments/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const LecturerOnlineClasses = createAsyncThunk(
  'lecturer-online-classes',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lec-portal/list-online-classes/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetCourseDates = createAsyncThunk('get-course-dates', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lec-portal/get-course-dates/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StoreOnlineClass = createAsyncThunk(
  'store-online-class',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`/api/lec-portal/store-online-class`, data)
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteOnlineClass = createAsyncThunk(
  'online-class-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/lec-portal/online-class-destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EvForm = createAsyncThunk('ev-form', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lec-portal/course-ev-form/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerAnnualFeedbackForm = createAsyncThunk(
  'lecturer-annual-feedback',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get('/api/lec-portal/annual-form')
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetAnnualFeeback = createAsyncThunk(
  'get-lecturer-annual-feedback',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lec-portal/get-annual-form`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createNewsLA = createAsyncThunk('news-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/lec-portal/store-news', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StoreAnnualForm = createAsyncThunk(
  'lecturer-ev-form-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/lec-portal/annual-form-store', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const LecturerFeedbackReport = createAsyncThunk(
  'lecturer-feedback-report',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lecturer/feedback-report/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const LecProfileEdit = createAsyncThunk('lec-pro-edit', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lec-portal/profile-edit`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecProfileUpdate = createAsyncThunk('lec-pro-update', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/lec-portal/profile-update', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ScheduleAcademicYears = createAsyncThunk(
  'schedule-academic-years',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lecturer-contract/schedule-academic-years`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const AcademicYearSemesters = createAsyncThunk(
  'ay-semesters',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lecturer-contract/academic-year-semesters/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const SemesterLecturers = createAsyncThunk('sem-lecturers', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lecturer-contract/semester-lectures/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerCourses = createAsyncThunk('lecturer-courses', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`/api/lecturer-contract/lecturer-courses`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerContractStore = createAsyncThunk(
  'contract-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/lecturer-contract/store', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const LecturerConts = createAsyncThunk('lecturer-contract-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/lecturer-contract/list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ContractDelete = createAsyncThunk('contract-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/lecturer-contract/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ContractDetails = createAsyncThunk(
  'get-lecturer-contract-details',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lecturer-contract/view/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const MyContracts = createAsyncThunk('my-contracts', async (_, thunkAPI) => {
  try {
    const res = await axios.get(`/api/lec-portal/my-contracts`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SignContract = createAsyncThunk('sign-contract', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`/api/lec-portal/sign-contract`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MgrSignContract = createAsyncThunk('mgr-sign-contract', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`/api/lecturer-contract/sign-contract`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const EditContractComments = createAsyncThunk(
  'edit-contract-comment',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lec-portal/edit-comment/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const UpdateContractComment = createAsyncThunk(
  'update-contract-comment',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`/api/lec-portal/update-comment`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetContractComment = createAsyncThunk(
  'get-contract-comment',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lecturer-contract/get-contract-comment/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const LecturerNews = createAsyncThunk('lecturer-news', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lec-portal/my-news`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const EmailContract = createAsyncThunk('email-contract', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lecturer-contract/email/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetLecList = createAsyncThunk('get-lecturer-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lecturer/get-lecturers`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreateUserForLecs = createAsyncThunk(
  'create-user-for-lecs',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/lecturer/create-user', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const UpdateAndEmailLecturerAccount = createAsyncThunk(
  'update-account-and-mail-lecturer',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lecturer/update-email-account/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StdAssignments = createAsyncThunk('std-assignments', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lec-portal/student-assignments/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const courseStatistics = createAsyncThunk('course-statics', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lec-portal/course-statistics/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AyEvReport = createAsyncThunk('ay-ev-report', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lec-portal/ay-ev-report/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PeerEvaluations = createAsyncThunk('peer-evaluations', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lec-portal/peer-forms`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetPeerEvaluation = createAsyncThunk(
  'get-peer-evaluation',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lec-portal/peer-evaluation/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StorePeerEvaluation = createAsyncThunk(
  'peer-form-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/lec-portal/peer-form-store', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PeerEvDetails = createAsyncThunk('peer-ev-details', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lec-portal/peer-ev-details/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const UpdatePeerEvaluation = createAsyncThunk(
  'peer-form-update',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/lec-portal/peer-form-update', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const SkipLecAnnForm = createAsyncThunk('skip-lec-ann-form', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/lec-portal/skip-ann-form', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrintLecturers = createAsyncThunk('print-lecturers', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/lecturer/print-lecturers', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerExcel = createAsyncThunk('lecturer-excel', async (params: {}) => {
  const response = await axios.get('/api/lecturer/excel-lecturers', {
    params,
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'Teaching Staff.xlsx'
  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
})

export const UploadExamPaper = createAsyncThunk('upload-exam-paper', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/lec-portal/upload-exam-paper', data)
    return res.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }

    return thunkAPI.rejectWithValue({
      message: 'server_error',
    })
  }
})

export const createContractTerm = createAsyncThunk(
  'store-contract-terms',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/lecturer-contract/store-contract-terms', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editContractTerm = createAsyncThunk('edit-contract-terms', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lecturer-contract/edit-contract-terms`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerContracts = createAsyncThunk('lec-contracts', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lecturer/contracts/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editContract = createAsyncThunk('edit-contract', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/lecturer/edit-contract/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createContract = createAsyncThunk('create-contract', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/lecturer/create-contract', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const inActiveContract = createAsyncThunk(
  'inactive-contract',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/lecturer/inactive-contract/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type LecturerState = {
  record: any
  records: any
  errors: any
}

const initialState: LecturerState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const lecturerSlice = createSlice({
  name: 'lecturer',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListLecturer.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(editLecturer.fulfilled, (state, action: PayloadAction<any>) => {
        state.record = action.payload
      })
      .addCase(createLecturer.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListArchivedLecturer.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(ListLecturerDocument.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(ListPublication.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
  },
})

export const {reset} = lecturerSlice.actions
export default lecturerSlice.reducer
